import { mixtilesAxios } from '../utils/ApiUtils'
import { type CheckoutBackupPayload } from '../services/CheckoutBackup/checkoutBackup.types'

// The backup lets us safely resume an in-progress order when a shopper returns from a third-party payment (Klarna etc.) redirect
// into a different browser: the frontend POSTs the checkout snapshot to Redis before redirecting, and if local/session
// storage is empty on return the frontend GETs the snapshot to restore the flow seamlessly.
const CHECKOUT_BACKUP_PATH = 'checkout-backup'

export const postCheckoutBackupData = async (
  paymentIntentId: string,
  createOrderParams: object,
  checkoutSingleProduct: object
): Promise<CheckoutBackupPayload> => {
  const payload = {
    paymentIntentId,
    createOrderParams,
    checkoutSingleProduct,
  }
  const response = await mixtilesAxios.post(CHECKOUT_BACKUP_PATH, payload)
  return response.data
}

export const getCheckoutBackupData = async (
  paymentIntentId: string
): Promise<CheckoutBackupPayload> => {
  const response = await mixtilesAxios.get(
    `${CHECKOUT_BACKUP_PATH}/${paymentIntentId}`
  )
  return response.data
}
